import { render } from "./Tickets.vue?vue&type=template&id=f361a82a"
import script from "./Tickets.vue?vue&type=script&lang=ts"
export * from "./Tickets.vue?vue&type=script&lang=ts"
script.render = render

export default script